<template>
  <div class="image-uploader">
    <!-- 动态图片区域 -->
    <div class="dynamic-image" 
         @click="handleGifClick" 
         :class="{ 'clickable': !uploadedImage }">
      <img src="../assets/logo-min.gif" alt="动态图片" />
    </div>

    <!-- 上传图片区域 -->
    <div class="upload-area" v-if="uploadedImage">
      <img v-if="uploadedImage" 
           :src="uploadedImage" 
           alt="上传的图片"
           @dblclick.stop="deleteImage"
           class="uploaded-image" />
    </div>

    <!-- 连接线 -->
    <div class="connector-container" v-if="uploadedImage">
      <div class="connector-line"></div>
    </div>

    <input
      type="file"
      ref="fileInput"
      @change="handleFileUpload"
      accept="image/*"
      style="display: none"
    />
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  data() {
    return {
      uploadedImage: null
    }
  },
  methods: {
    handleGifClick() {
      // 只有在没有上传图片时才触发上传
      if (!this.uploadedImage) {
        this.triggerUpload()
      }
    },
    triggerUpload() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.uploadedImage = e.target.result
        }
        reader.readAsDataURL(file)
      }
      event.target.value = ''
    },
    deleteImage() {
      this.uploadedImage = null
    }
  }
}
</script>

<style scoped>
.image-uploader {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  transform: scale(0.7);
  min-height: 400px;
}

.dynamic-image {
  width: 175px;
  height: 175px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  position: relative;
  z-index: 2;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.dynamic-image.clickable {
  cursor: pointer;
}

.dynamic-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(4.7);
  outline: none;
  border: none;
}

.upload-area {
  width: 147px;
  height: 147px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  background: transparent;
  position: absolute;
  top: 210px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  outline: none;
  border: none;
}

.connector-container {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2px;
  z-index: 1;
}

.connector-line {
  width: 100%;
  height: 100%;
  background: #f5e5ab;
}
</style> 